import { Checkbox } from 'antd';
import type { AppCheckboxProps } from './Checkbox.types';

export const AppCheckbox = (props: AppCheckboxProps) => {
  return <Checkbox {...props} />;
};
